import { useSelector } from 'react-redux'
import { getBackbarFinalizeDialogOpen } from '../../Selectors'
import { VNBackBarMissingPaymentModal } from './VNBackBarMissingPaymentModal'
import { VNBackBarEnterTipModal } from './VNBackBarEnterTipModal'

export const VNBackBarFinalizeModals = () => {
  const isOpen = useSelector(getBackbarFinalizeDialogOpen)

  if (!isOpen) {
    return null
  }

  return (
    <>
      <VNBackBarMissingPaymentModal />
      <VNBackBarEnterTipModal />
    </>
  )
}
